export const DRAFTJS = 'DRAFTJS';
export const TINYMCE = 'TINYMCE';